<!--
 * @Copyright: 12308
 * @Author: xuxinxiang
 * @Date: 2020-04-10 17:08:25
 * @LastEditTime: 2020-04-13 17:21:10
 * @Description: 面包屑导航
 -->
<template>
    <div class="crumbs">
        <img class="icon_home" src="@/assets/front/icon-home.png" />
        <ul>
            <li>
                <router-link :to="{ path: '/product-list' }">Home</router-link
                ><img src="@/assets/front/icon-arrow2.png" />
            </li>
            <li
                v-for="(item, index) in $route.matched.filter(
                    (m) => m.meta.title
                )"
                :key="index"
            >
                <router-link :to="item.path"
                    >{{ item.meta.title
                    }}<img src="@/assets/front/icon-arrow2.png"
                /></router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "Crumbs",
    data() {
        return {};
    },
};
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/pages/front/components/crumbs.vue